<template>
	<div class="delivery-body">
		<div class="fx-title">
			<p>订单详情</p>
		</div>
		<div class="delivery-info">

			<p>下单时间： {{createdate}}</p>
			<p>订单编号：<el-button type='text' @click="btnClick">{{deliveryData.ordernumber}}</el-button>
				<img
					src="~/images/icon/copy-icon.png"
					class="copy"
					v-clipboard:copy="deliveryData.ordernumber"
					v-clipboard:success="onCodeCopy"
					v-clipboard:error="onCodeError">
			</p>
			<p v-for="item in deliveryData.orderForConsumerList" :key="item.orderId" style="justify-content: flex-end;">
				<el-button type='text' @click="btnClick(item, '1')">{{item.orderNumber}}</el-button>
				<span class="dai-text">代</span>
				<img
					src="~/images/icon/copy-icon.png"
					class="copy"
					v-clipboard:copy="item.orderNumber"
					v-clipboard:success="onCodeCopy"
					v-clipboard:error="onCodeError">
			</p>
			<p>{{deliveryData.customerCategoryName}}：{{deliveryData.customerName}}</p>
			<!-- <p>采购门店：<span v-if='deliveryData.ob_storename !== "个人"'>{{deliveryData.ob_entname}}-</span>{{deliveryData.ob_storename}}</p> -->
			<p>收货人： {{deliveryData.ob_name}}</p>
			<p>联系方式：{{deliveryData.ob_btel}}</p>
			<p v-if="deliveryData.selfPickFlag === 0">收货地址： {{deliveryData.ob_address}}</p>
			<div v-if="deliveryData.selfPickFlag === 1">
				<p>自提点： {{deliveryData.selfPickAddress}}</p>
				<p>联系人： {{deliveryData.selfPickLinkName}}</p>
				<p>联系方式： {{deliveryData.selfPickTel}}</p>
				<p>自提时间： {{deliveryData.selfPickDate}}</p>
				<p>物流公司：{{name}} </p>
			</div>
			<p>物流单号：
				{{code}}
				<img
					v-if="code !== ''"
					src="~/images/icon/copy-icon.png"
					class="copy"
					v-clipboard:copy="code"
					v-clipboard:success="onCodeCopy"
					v-clipboard:error="onCodeError">
			</p>
		</div>
		<div class="fx-title">
			<p>跟踪退单</p>
		</div>
		<div class="block">
			<el-timeline>
				<el-timeline-item
					v-for="(item, index) in timeList"
					:key="index"
					:color="index === 0 ? '#F95151':'E4E7ED'"
					hide-timestamp
					:timestamp="item.time">
					<div>
						<p>{{item.title}}
							<span style="margin-left: 10px;color: #999;">{{item.createDate}}</span>
						</p>
						<div>
							<h5 v-for="msgItem in item.message" :key="msgItem">{{msgItem}}</h5>
						</div>
						<p style="color:#999999;">操作人：{{item.userName}}</p>
					</div>
				</el-timeline-item>
			</el-timeline>
		</div>
	</div>
</template>

<script>
export default {
	name: 'deliveryInfo',
	props: {
		deliveryData: Object
	},
	watch: {
		deliveryData: {
			handler (val) {
				this.organid = val.os_organid
				if (val.fulfillment && val.fulfillment.ffm_number && val.fulfillment.ffm_companycode) {
					this.code = val.fulfillment.ffm_number
					this.name = val.fulfillment.ffm_companycode
				}
				if (val.refundid) {
					this.getTimeLine()
				}
				this.createdate = this.formatTime(val.createdate, 'Y/M/D h:m:s')
			},
			immediate: true
		}
	},
	data () {
		return {
			flag: false,
			statusCode: '',
			createdate: '',
			name: '',
			code: '',
			tabParams: {},
			orderParams: {},
			timeList: [],
			organid: ''
		}
	},
	methods: {
		onCodeCopy (e) {
			this.$message.success('复制成功！')
		},
		onCodeError (e) {
			this.$message.error('复制失败！')
		},
		formatTime (number, format) {
			var formateArr = ['Y', 'M', 'D', 'h', 'm', 's']
			var returnArr = []

			var date = new Date(number)
			returnArr.push(date.getFullYear())
			returnArr.push(this.formatNumber(date.getMonth() + 1))
			returnArr.push(this.formatNumber(date.getDate()))
			returnArr.push(this.formatNumber(date.getHours()))
			returnArr.push(this.formatNumber(date.getMinutes()))
			returnArr.push(this.formatNumber(date.getSeconds()))

			for (var i in returnArr) {
				format = format.replace(formateArr[i], returnArr[i])
			}
			return format
		},
		formatNumber (n) {
			n = n.toString()
			return n[1] ? n : '0' + n
		},
		btnClick (val, type) {
			this.orderParams = {}
			this.tabParams = {}
			if (type === '1') {
				this.tabParams.organid = this.organid
				this.tabParams.isSellerpull = this.deliveryData.isSellerpull
				this.tabParams.sellerShopId = this.deliveryData.sellerShopId
				this.tabParams.orderStatus = +val.orderStatus
				this.orderParams.buypullstate = val.buyPullState
				this.orderParams.differ = val.differFlag
				this.orderParams.orderId = val.orderId
				this.orderParams.statusId = val.orderStatusId
			} else {
				this.tabParams.organid = this.organid
				this.tabParams.isSellerpull = this.deliveryData.isSellerpull
				this.tabParams.sellerShopId = this.deliveryData.sellerShopId
				this.tabParams.orderStatus = +this.deliveryData.billState
				this.orderParams.buypullstate = this.deliveryData.buypullstate
				this.orderParams.differ = this.deliveryData.differ
				this.orderParams.orderId = this.deliveryData.orderId
				this.orderParams.statusId = this.deliveryData.statusId
			}
			switch (this.deliveryData.billState) {
			case '0':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '1':
				this.tabParams.active = '待付款'
				this.orderParams.billState = '待付款'
				break
			case '2':
				if (this.deliveryData.isSellerpull) {
					this.tabParams.active = '备货中'
					this.orderParams.billState = '备货中'
				} else {
					this.tabParams.active = '待付款'
					this.orderParams.billState = '待付款'
				}
				break
			case '3':
				this.tabParams.active = '待收货'
				this.orderParams.billState = '待收货'
				break
			case '4':
				this.tabParams.active = '已完成'
				this.orderParams.billState = '已完成'
				break
			case '5':
				this.tabParams.active = '已取消'
				this.orderParams.billState = '已取消'
				break
			}
			if (this.tabParams.orderStatus === 0) {
				this.statusCode = '07_0001_0001_00'
			} else if (this.tabParams.orderStatus === 1) {
				this.statusCode = '07_0001_0004_00'
			} else if (this.tabParams.orderStatus === 2) {
				if (this.tabParams.isSellerpull === true) {
					this.statusCode = '07_0001_0010_00'
				} else {
					this.statusCode = '07_0001_0007_00'
				}
			} else if (this.tabParams.orderStatus === 3) {
				this.statusCode = '07_0001_0013_00'
			} else if (this.tabParams.orderStatus === 4) {
				this.statusCode = '07_0001_0016_00'
			} else if (this.tabParams.orderStatus === 5) {
				this.statusCode = '07_0001_0019_00'
			}
			this.getAuthority(this.statusCode)
		},
		getAuthority (val) {
			let params = {
				pId: '07_0001_0000_00'
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					this.flag = false
					for (let i = 0; i < a.length; i++) {
						if (a[i] === val) {
							console.log(a[i])
							this.flag = true
						}
					}
					if (this.flag) {
						window.sessionStorage.setItem('tabInfo', JSON.stringify(this.tabParams))
						window.sessionStorage.setItem('orderInfo', JSON.stringify(this.orderParams))
						this.$fxEventBus.$emit('setMenu', '6-1')
						this.$router.push('/main/orderDetail')
					} else {
						this.$message.error('没有订单权限，不能进入订单详情界面')
					}
				}
			})
		},
		getTimeLine () {
			let params = {
				orderId: this.deliveryData.refundid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/order/getOrderfollows`,
				data: params
			}).then(res => {
				if (res.result) {
					this.timeList = []
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						// a[i].modifydate = a[i].modifydate.slice(0, 16)
						if (a[i].title === '拒绝退货') {
							switch (a[i].cause) {
							case 1:
								a[i].message = ['质量无问题']
								break
							case 2:
								a[i].message = ['超出退货时间']
								break
							case 3:
								a[i].message = ['问题已解决']
								break
							case 4:
								a[i].message = ['该商品不符合无理由退货']
								break
							case 5:
								a[i].message = ['影响二次销售']
								break
							default:
								a[i].message = a[i].message.length === 0 ? ['其他原因'] : a[i].message
								break
							}
						}
						if (a[i].title === '申请退货') {
							switch (a[i].cause) {
							case 0:
								a[i].message = ['无理由退换']
								break
							case 1:
								a[i].message = ['质量问题']
								break
							case 2:
								a[i].message = ['与商品描述不符合']
								break
							case 3:
								a[i].message = ['卖家发错货']
								break
							case 4:
								a[i].message = ['发票问题']
								break
							default:
								a[i].message = ['其他原因']
								break
							}
						}

						// switch (a[i].status) {
						// case 0:
						// 	a[i].status = '申请退货'
						// 	break
						// case 1:
						// 	a[i].status = '卖家同意'
						// 	break
						// case 2:
						// 	a[i].status = '卖家拒绝'
						// 	break
						// case 3:
						// 	a[i].status = '退货完成'
						// 	break
						// case 4:
						// 	a[i].status = '卖家驳回'
						// 	break
						// case 5:
						// 	a[i].status = '卖家编辑'
						// 	break
						// }
						// if (i === 0) {
						// 	this.timeList.unshift({
						// 		time: a[i].modifydate,
						// 		status: a[i].status,
						// 		cause: a[i].cause,
						// 		username: a[i].username
						// 	})
						// } else {
						// 	this.timeList.unshift({
						// 		time: a[i].modifydate,
						// 		status: a[i].status,
						// 		cause: a[i].cause,
						// 		username: a[i].username
						// 	})
						// }
					}
					this.timeList = a
					console.log(this.timeList)
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.delivery-body {
	font-size: 14px
	padding :10px;
	background-color:#F8FCFF;
	border :1px solid #DCE2FD;
	border-radius :4px;
	overflow-y:auto;
	.el-button--text{
		padding 0px
		height :18px
		line-height 18px
	}
	.copy{
		cursor: pointer
		display inline-block
		width: 16px
		height: 18px
		vertical-align: top
	}
	.fx-title {
		font-weight: 700
		margin: 0 0 18px 0
	}
	.delivery-info {
		padding: 0
		text-align: left
		border-bottom 1px solid #DCE1FE
		margin-bottom: 15px
		p {
			display: flex
			margin-bottom: 18px
			i {
				color: var(--fx-primary-color)
				cursor: pointer
			}
		}
		.dai-text {
			display: inline-block;
			width: 16px;
			height: 16px;
			line-height: 16px;
			border: 1px solid #f38e0b;
			border-radius: 4px;
			color: #f38e0b;
			font-size: 10px;
			-webkit-transform: scale(0.9);
			transform: scale(0.9);
			margin-left: 3px;
		}
	}
	.dialog-body {
		p {
			margin-bottom: 10px
		}
		.delivery-input {
			width: 100%
			margin-bottom: 10px
			&:last-child {
				margin-top: 20px
			}
		}
	}
	.block {
		text-align: left
		h5 {
			color: #F95151
		}
	}
}
</style>
<style lang="stylus">
.delivery-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
.el-timeline-item__wrapper{
	top:-5px;
}
</style>
